import * as React from 'react';
import Grid from '@mui/material/Grid2';
import { observer } from 'mobx-react';

const UserProfile = observer(() => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 12 }}>
        <div>Profile (coming soon)</div>
      </Grid>
    </Grid>
  );
});

export default UserProfile;
